module.exports = __webpack_public_path__ + "img/23.05b61f90.png";